import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';

// Keep operator-managed saved cards separate from Stripe's consumer Link wallet.
export default function LinkDisabledCardElement(props: React.ComponentProps<typeof CardElement>) {
  return <CardElement {...props} options={{ ...props.options, disableLink: true }} />;
}
